// components/ImageUploader.jsx
import React, { memo } from "react";
import Image from "next/image";
import { X } from "lucide-react";

const ImageUploader = memo(
  ({ handleImageSelect, imagePreviews, uploadProgress, removeImage }) => (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          Upload Images
        </label>
        <label className="cursor-pointer bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2 rounded-lg transition-colors">
          <span className="text-sm font-medium">Choose Files</span>
          <input
            type="file"
            accept="image/jpeg, image/png, image/gif"
            multiple
            className="hidden"
            onChange={handleImageSelect}
          />
        </label>
      </div>

      {imagePreviews.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mt-4">
          {imagePreviews.map((preview, index) => (
            <div key={index} className="relative group">
              <div className="aspect-square relative rounded-lg overflow-hidden border border-gray-200">
                <Image
                  src={preview.preview}
                  alt={`Preview ${index + 1}`}
                  fill
                  sizes="(max-width: 768px) 40vw, 15vw"
                  className="object-cover transition-opacity group-hover:opacity-75"
                />
                {uploadProgress[index] !== undefined &&
                  uploadProgress[index] < 100 && (
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                      <div className="text-white font-medium">
                        {uploadProgress[index]}%
                      </div>
                    </div>
                  )}
              </div>
              <button
                onClick={() => removeImage(index)}
                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                aria-label="Remove image"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
);

export default ImageUploader;
